import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector, Field, reduxForm } from "redux-form";
import { getTranslate } from "react-localize-redux";
import classnames from "classnames";
import PolicyRegScrollbar from "../../../../components/PolicyRegScrollbar/PolicyRegScrollbar";
import "./PaymentStep.css";
import { BeatLoader } from "react-spinners";
import PayfyLogo from "../../../../assets/images/pay/payfy.svg";
import LiberyLogo from "../../../../assets/images/pay/liberty.svg";
import Boglogo from "../../../../assets/images/pay/bog.svg";
import Tpllogo from "../../../../assets/images/pay/tpl.svg";
import CardVisa from "../../../../assets/images/pay/visa.svg";
import CardAmex from "../../../../assets/images/pay/amex.svg";
class PaymentStep extends Component {
  constructor() {
    super();

    this.state = {
      buttonDisable: false,
    };
  }

  handelPaymentProviderLogo = (bank) => {
    switch (bank) {
      case 0: return LiberyLogo;
      case 1: return Boglogo;
      case 2: return PayfyLogo;
    }
  };

  render() {
    const {
      previousPage,
      onClick,
      isPaying,
      translate,
      ecommerceList,
      selectedBank,
      handleSelectedBank,
      bankType,
      premium,
      canPay = true,
    } = this.props;
    return (
      <div className="policy-registration-container container-pay">
        <div className="policy-title">{translate("payments")}</div>
        <div
          className="policy-create-card policy-create-card-pay"
          id="policy-create-card"
        >
          <PolicyRegScrollbar numb={5} />
          <div className="policy-block">
            {ecommerceList && (
              <form>
                <span className="select-bank">{translate("selectBank")}</span>
                <div className="input-radio-group">
                  {ecommerceList.map((item, index) => (

                    <div key={index}
                      className={classnames("input-radio-block", {
                        "active": selectedBank === item.bank,
                      })}
                    >
                      <div className="radio-box">
                        <div className="input-radio">
                          <label className="input-radio-label">
                            <Field
                              name="ecommerceListForm"
                              value={item.bank}
                              component="input"
                              type="radio"
                              checked={selectedBank === item.bank}
                              onChange={() => {
                                handleSelectedBank(item.bank);
                              }}
                            />
                            <span className="input-radio-circle" />
                            <span className="input-radio-text">
                              <div className="logo">
                                <img src={this.handelPaymentProviderLogo(item.bank)} />
                              </div>
                            </span>
                          </label>
                        </div>
                        <div>
                          <div className="card-name">
                            {" "}
                            {translate(bankType[item.bank])}
                          </div>
                          <div className="card-type">
                            <span className="card-type__label">
                              {translate("geoCard")}:
                            </span>
                            <span className="card-type__value">
                              {item.cardProcessingFee}%
                            </span>
                          </div>
                          <div className="card-type">
                            <span className="card-type__label">
                              {translate("notGeoCard")}:
                            </span>
                            <span className="card-type__value">
                              {item.foreignCardProcessingFee}%
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="card-block">
                        <img src={CardVisa} />
                        {item.bank == 1 && <img src={CardAmex} />}
                      </div>
                    </div>
                  ))}
                </div>
              </form>
            )}
            <div className="policy-price-block">
              <div className="">
                <p className="policy-price-description">
                  {translate("paymentAmount")}
                </p>
                <div className="policy-price-details">
                  <div className="main-logo">
                    <img src={Tpllogo} />
                  </div>
                  <div className="text-info">
                    <p>TPL </p>
                   
                  </div>
                  <div className="policy-price-value">
                    <span> {premium ? premium : "-" + "-"}</span>
                    <p className="policy-price-lari">GEL</p>
                  </div>
                </div>
              </div>

              <div className="policy-pay-text-block">
                <h4 className="policy-pay-text">
                  {" "}
                  {translate("payAdditionalText")}
                </h4>
              </div>
            </div>
          </div>
          <div className="step-btn-content viewStep-btns-mobile">
            <button className="back-btn" onClick={previousPage}>
              {" "}
              {translate("back")}
            </button>

            {isPaying && (
              <div className="Loader">
                <BeatLoader size={11} color={"#B5DB39"} />
              </div>
            )}
            {!isPaying && (
              <button
                className={classnames("policy-pay-btn-disable", {
                  "policy-pay-btn":
                    canPay && (selectedBank || selectedBank === 0),
                })}
                disabled={!canPay || (selectedBank !== 0 && !selectedBank)}
                onClick={onClick}
              >
                {" "}
                {translate("pay")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

PaymentStep = reduxForm({
  form: "ecommerceListFormInPaymentStep", // a unique identifier for this form
})(PaymentStep);

const selector = formValueSelector("CreatePolicyForm");

const mapStateToProps = (state) => {
  const startDate = selector(state, "startDate");
  const endDate = selector(state, "endDate");
  const issueDateDiff = selector(state, "issueDateDiff");
  const dayType = selector(state, "dayType");
  const vehicleCategoryName = selector(state, "vehicleCategoryName");
  const premium = selector(state, "premium");
  return {
    translate: getTranslate(state.locale),
    startDate,
    endDate,
    issueDateDiff,
    dayType,
    premium,
    vehicleCategoryName,
  };
};

export default connect(mapStateToProps)(PaymentStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/PaymentStep/PaymentStep.js